import React from 'react'
import NavBar from './NavBar'
import styled from 'styled-components'


function Header({ }) {
    return (
        <div>
            <div className="header">
                <NavBar  />
            </div>
        </div>
    )
}

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    background: "white";
`


export default Header
